import React from 'react'
import { Modal, Button } from 'react-bootstrap';
const TermsModal = (props) => {
  return (
    <div className="container">
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            General Terms and Condition
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h1>Terms and conditions</h1>
          <p>
            These terms and conditions (&quot;Terms&quot;,
            &quot;Agreement&quot;) are an agreement between Website Operator
            (&quot;Website Operator&quot;, &quot;us&quot;, &quot;we&quot; or
            &quot;our&quot;) and you (&quot;User&quot;, &quot;you&quot; or
            &quot;your&quot;). This Agreement sets forth the general terms and
            conditions of your use of the{" "}
            <a
              target="_blank"
              rel="nofollow"
              href="http://www.payaftersalary.com"
            >
              Pay After Salary System Limited
            </a>{" "}
            website and any of its products or services (collectively,
            &quot;Website&quot; or &quot;Services&quot;).
          </p>
          <h3>Accounts and membership</h3>
          <p>
            You must be at least 18 years of age to use this Website. By using
            this Website and by agreeing to this Agreement you warrant and
            represent that you are at least 18 years of age. If you create an
            account on the Website, you are responsible for maintaining the
            security of your account and you are fully responsible for all
            activities that occur under the account and any other actions taken
            in connection with it. We may monitor and review new accounts before
            you may sign in and use our Services. Providing false contact
            information of any kind may result in the termination of your
            account. You must immediately notify us of any unauthorized uses of
            your account or any other breaches of security. We will not be
            liable for any acts or omissions by you, including any damages of
            any kind incurred as a result of such acts or omissions. We may
            suspend, disable, or delete your account (or any part thereof) if we
            determine that you have violated any provision of this Agreement or
            that your conduct or content would tend to damage our reputation and
            goodwill. If we delete your account for the foregoing reasons, you
            may not re-register for our Services. We may block your email
            address and Internet protocol address to prevent further
            registration.
          </p>
          <h3>Links to other websites</h3>
          <p>
            Although this Website may link to other websites, we are not,
            directly or indirectly, implying any approval, association,
            sponsorship, endorsement, or affiliation with any linked website,
            unless specifically stated herein. We are not responsible for
            examining or evaluating, and we do not warrant the offerings of, any
            businesses or individuals or the content of their websites. We do
            not assume any responsibility or liability for the actions,
            products, services, and content of any other third parties. You
            should carefully review the legal statements and other conditions of
            use of any website which you access through a link from this
            Website. Your linking to any other off-site websites is at your own
            risk.
          </p>
          <h3>Prohibited uses</h3>
          <p>
            In addition to other terms as set forth in the Agreement, you are
            prohibited from using the Website or its Content: (a) for any
            unlawful purpose; (b) to solicit others to perform or participate in
            any unlawful acts; (c) to violate any international, federal,
            provincial or state regulations, rules, laws, or local ordinances;
            (d) to infringe upon or violate our intellectual property rights or
            the intellectual property rights of others; (e) to harass, abuse,
            insult, harm, defame, slander, disparage, intimidate, or
            discriminate based on gender, sexual orientation, religion,
            ethnicity, race, age, national origin, or disability; (f) to submit
            false or misleading information; (g) to upload or transmit viruses
            or any other type of malicious code that will or may be used in any
            way that will affect the functionality or operation of the Service
            or of any related website, other websites, or the Internet; (h) to
            spam, phish, pharm, pretext, spider, crawl, or scrape; (i) for any
            obscene or immoral purpose; or (j) to interfere with or circumvent
            the security features of the Service or any related website, other
            websites, or the Internet. We reserve the right to terminate your
            use of the Service or any related website for violating any of the
            prohibited uses.
          </p>
          <h3>Intellectual property rights</h3>
          <p>
            &quot;Intellectual Property Rights&quot; means all present and
            future rights conferred by statute, common law or equity in or in
            relation to any copyright and related rights, trademarks, designs,
            patents, inventions, goodwill and the right to sue for passing off,
            rights to inventions, rights to use, and all other intellectual
            property rights, in each case whether registered or unregistered and
            including all applications and rights to apply for and be granted,
            rights to claim priority from, such rights and all similar or
            equivalent rights or forms of protection and any other results of
            intellectual activity which subsist or will subsist now or in the
            future in any part of the world. This Agreement does not transfer to
            you any intellectual property owned by Website Operator or third
            parties, and all rights, titles, and interests in and to such
            property will remain (as between the parties) solely with Website
            Operator. All trademarks, service marks, graphics and logos used in
            connection with the Website or Services, are trademarks or
            registered trademarks of Website Operator or Website Operator
            licensors. Other trademarks, service marks, graphics and logos used
            in connection with the Website or Services may be the trademarks of
            other third parties. Your use of the Website and Services grants you
            no right or license to reproduce or otherwise use any Website
            Operator or third party trademarks.
          </p>
          <h3>Limitation of liability</h3>
          <p>
            To the fullest extent permitted by applicable law, in no event will
            Website Operator, its affiliates, directors, officers, employees,
            agents, suppliers or licensors be liable to any person for any
            indirect, incidental, special, punitive, cover or consequential
            damages (including, without limitation, damages for lost profits,
            revenue, sales, goodwill, use of content, impact on business,
            business interruption, loss of anticipated savings, loss of business
            opportunity) however caused, under any theory of liability,
            including, without limitation, contract, tort, warranty, breach of
            statutory duty, negligence or otherwise, even if the liable party
            has been advised as to the possibility of such damages or could have
            foreseen such damages. To the maximum extent permitted by applicable
            law, the aggregate liability of Website Operator and its affiliates,
            officers, employees, agents, suppliers and licensors relating to the
            services will be limited to an amount greater of one dollar or any
            amounts actually paid in cash by you to Website Operator for the
            prior one month period prior to the first event or occurrence giving
            rise to such liability. The limitations and exclusions also apply if
            this remedy does not fully compensate you for any losses or fails of
            its essential purpose.
          </p>
          <h3>Indemnification</h3>
          <p>
            You agree to indemnify and hold Website Operator and its affiliates,
            directors, officers, employees, agents, suppliers and licensors
            harmless from and against any liabilities, losses, damages or costs,
            including reasonable attorneys' fees, incurred in connection with or
            arising from any third party allegations, claims, actions, disputes,
            or demands asserted against any of them as a result of or relating
            to your Content, your use of the Website or Services or any willful
            misconduct on your part.
          </p>
          <h3>Severability</h3>
          <p>
            All rights and restrictions contained in this Agreement may be
            exercised and shall be applicable and binding only to the extent
            that they do not violate any applicable laws and are intended to be
            limited to the extent necessary so that they will not render this
            Agreement illegal, invalid or unenforceable. If any provision or
            portion of any provision of this Agreement shall be held to be
            illegal, invalid or unenforceable by a court of competent
            jurisdiction, it is the intention of the parties that the remaining
            provisions or portions thereof shall constitute their agreement with
            respect to the subject matter hereof, and all such remaining
            provisions or portions thereof shall remain in full force and
            effect.
          </p>
          <h3>Dispute resolution</h3>
          <p>
            The formation, interpretation, and performance of this Agreement and
            any disputes arising out of it shall be governed by the substantive
            and procedural laws of Nigeria without regard to its rules on
            conflicts or choice of law and, to the extent applicable, the laws
            of Nigeria. The exclusive jurisdiction and venue for actions related
            to the subject matter hereof shall be the courts located in Nigeria,
            and you hereby submit to the personal jurisdiction of such courts.
            You hereby waive any right to a jury trial in any proceeding arising
            out of or related to this Agreement. The United Nations Convention
            on Contracts for the International Sale of Goods does not apply to
            this Agreement.
          </p>
          <h3>Changes and amendments</h3>
          <p>
            We reserve the right to modify this Agreement or its policies
            relating to the Website or Services at any time, effective upon
            posting of an updated version of this Agreement on the Website. When
            we do, we will revise the updated date at the bottom of this page.
            Continued use of the Website after any such changes shall constitute
            your consent to such changes.
            <h3>Acceptance of these terms</h3>
            <p>
              You acknowledge that you have read this Agreement and agree to all
              its terms and conditions. By using the Website or its Services you
              agree to be bound by this Agreement. If you do not agree to abide
              by the terms of this Agreement, you are not authorized to use or
              access the Website and its Services.
            </p>
            <h3>Contacting us</h3>
            <p>
              If you would like to contact us to understand more about this
              Agreement or wish to contact us concerning any matter relating to
              it, you may send an email to
              contact&#64;&#112;aya&#102;te&#114;&#115;&#97;la&#114;y&#46;&#99;o&#109;
            </p>
            <p>This document was last updated on June 17, 2022</p>
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default TermsModal